module.exports = __webpack_public_path__ + "img/layout_vertical_right.5505fa9d.svg";